/* Mein Moodsup: tabs with shareable hashes and the personal referral link. */
(() => {
  const account = document.querySelector('[data-ms-account]');
  if (!account) return;

  const tabs = [...account.querySelectorAll('[data-account-tab]')];
  const panels = [...account.querySelectorAll('[data-account-panel]')];
  const select = (key, updateHash = true) => {
    if (!tabs.some(tab => tab.dataset.accountTab === key)) return;
    tabs.forEach(tab => {
      const active = tab.dataset.accountTab === key;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    panels.forEach(panel => { panel.hidden = panel.dataset.accountPanel !== key; });
    if (updateHash) history.replaceState(null, '', `#${key}`);
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(tab.dataset.accountTab));
    tab.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const next = tabs[(index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      next.focus();
      select(next.dataset.accountTab);
    });
  });
  account.querySelectorAll('[data-account-open]').forEach(button => button.addEventListener('click', () => {
    select(button.dataset.accountOpen);
    account.querySelector('.ms-account-tabs')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));
  select(location.hash.slice(1) || 'overview', false);
  window.addEventListener('hashchange', () => select(location.hash.slice(1) || 'overview', false));

  // The code is signed in Liquid (customer id + HMAC); the crediting Flow verifies the signature.
  const referral = account.querySelector('[data-referral]');
  if (!referral || !/^\d{6,16}-[0-9a-f]{8}$/.test(referral.dataset.code || '')) return;
  const link = `${referral.dataset.base}/?ref=${referral.dataset.code}`;
  const input = referral.querySelector('[data-referral-link]');
  const message = `${referral.dataset.message} ${link}`;
  input.value = link;

  const copy = referral.querySelector('[data-referral-copy]');
  copy.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(link); } catch (_) { input.select(); document.execCommand('copy'); }
    const label = copy.firstChild.textContent;
    copy.firstChild.textContent = referral.dataset.copied;
    setTimeout(() => { copy.firstChild.textContent = label; }, 2000);
  });

  const urls = {
    mail: `mailto:?subject=${encodeURIComponent('Moodsup')}&body=${encodeURIComponent(message)}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(message)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`,
    x: `https://twitter.com/intent/tweet?text=${encodeURIComponent(referral.dataset.message)}&url=${encodeURIComponent(link)}`,
  };
  referral.querySelectorAll('[data-referral-channel]').forEach(anchor => { anchor.href = urls[anchor.dataset.referralChannel]; });

  const native = referral.querySelector('[data-referral-native]');
  if (navigator.share) {
    native.hidden = false;
    native.addEventListener('click', () => navigator.share({ title: 'Moodsup', text: referral.dataset.message, url: link }).catch(() => {}));
  }
})();

(() => {
  document.querySelectorAll('[data-copy-code]').forEach(button => button.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(button.dataset.copyCode); } catch (_) { return; }
    const label = button.textContent;
    button.textContent = button.dataset.copied;
    setTimeout(() => { button.textContent = label; }, 2000);
  }));
})();
